import React from "react";
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faArrowUp,
} from '@fortawesome/free-solid-svg-icons';

interface Props {
  selectedDirection: number;
  onClick: (arg0: number) => void;
}

export default function DirectionalSelection(props: Props) {
	const { onClick, selectedDirection } = props;
	return (
		<div className="directional-selection">
			<div
				className={
					classNames(
						'first',
						'number',
						selectedDirection === 0 ? 'active' : 'deactive',
					)}
				onClick={() => onClick(0)}
			>
				<FontAwesomeIcon icon={faArrowLeft} />
			</div>
			<div
				className={
					classNames(
						'number',
						selectedDirection === 1 ? 'active' : 'deactive',
					)}
				onClick={() => onClick(1)}
			>
				<FontAwesomeIcon icon={faArrowRight} />
			</div>
			<div
				className={
					classNames(
						'number',
						selectedDirection === 2 ? 'active' : 'deactive',
					)}
				onClick={() => onClick(2)}
			>
				<FontAwesomeIcon icon={faArrowUp} />
			</div>
			<div
				className={
					classNames(
						'last',
						'number',
						selectedDirection === 3 ? 'active' : 'deactive',
					)}
				onClick={() => onClick(3)}
			>
				<FontAwesomeIcon icon={faArrowDown} />
			</div>
		</div>
	)
}
